import {ItemToolEditor} from "./CreatePriceGroup.jsx";
export default function CreateProductServices(props){return <ItemToolEditor {...props} kind="service"/>;}
